
import React from "react";
import { FaPhoneAlt, FaEnvelope, FaDownload } from "react-icons/fa";

const ResumeDatabase = () => {
  return (
    <div className="flex-1 bg-white p-6 min-h-screen">
      {/* Heading Section */}

<div className="max-w-4xl   mt-6">
  <h1 className="text-3xl font-bold text-gray-900 leading-tight mb-3">
    Find qualified candidates in minutes
  </h1>

  <div className="flex  gap-2 mb-6">
    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-black" fill="currentColor" viewBox="0 0 20 20">
      <path d="M10 18a8 8 0 100-16 8 8 0 000 16zm.75-11.75a.75.75 0 10-1.5 0v3.59L7.6 9.65a.75.75 0 10-.9 1.2l3 2.25a.75.75 0 00.9 0l3-2.25a.75.75 0 00-.9-1.2l-1.65 1.19V6.25z" />
    </svg>
    <p className="text-sm text-gray-700">Over <strong>320K</strong> resumes added monthly!</p>
  </div>

  <button className="bg-black text-white font-medium px-6 py-2 rounded-md text-base shadow">
    Browse the Database
  </button>
</div>
      {/* Fast hires section */}
      <div className="max-w-6xl mt-12">
        <h2 className="text-3xl font-semibold text-gray-900 mb-6">
          Fast hires, zero waiting
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Card 1 - Contact Info */}
          <div className="bg-green-50 p-6 rounded-lg text-center">
            <div className="bg-white shadow-md rounded-lg p-4">
              <h3 className="font-semibold text-gray-800 mb-2">Contact Info</h3>
              <div className="flex flex-col items-start gap-2 text-gray-700 text-sm mb-3">
                <div className="flex items-center gap-2">
                  <FaPhoneAlt className="text-gray-500" />
                  <span>123-123-123</span>
                </div>
                <div className="flex items-center gap-2">
                  <FaEnvelope className="text-gray-500" />
                  <span>ziprecruiter@gmail.com</span>
                </div>
              </div>
              <button className="w-full bg-gray-200 hover:bg-gray-300 text-sm font-medium py-1.5 rounded shadow-sm flex items-center justify-center gap-2">
                <FaDownload />
                Download Resume
              </button>
            </div>
            <p className="mt-4 text-sm text-gray-800 font-semibold">
              Unlock contact info instantly
            </p>
            <p className="text-sm text-gray-600 mt-1">
              Access your favorite candidate's phone number and email with just one click.
            </p>
          </div>

          {/* Card 2 - Certifications */}
          <div className="bg-green-50 p-6 rounded-lg text-center">
            <div className="bg-white shadow-md rounded-lg p-4 mb-4">
              <h3 className="font-semibold text-gray-800 text-sm mb-2">Certifications & Licenses</h3>
              <input
                type="text"
                placeholder="Certified |"
                className="w-full px-3 py-1.5 border rounded text-sm mb-2 focus:outline-none focus:ring-1 focus:ring-green-500"
              />
              <p className="text-sm text-gray-800">Certified Nursing Assistant</p>
            </div>
            <p className="text-sm text-gray-800 font-semibold">Identify the right fit, faster</p>
            <p className="text-sm text-gray-600 mt-1">
              Streamline your searches with smart, intuitive filters and stay organized with projects.
            </p>
          </div>

          {/* Card 3 - Filters */}
          <div className="bg-green-50 p-6 rounded-lg text-center">
            <div className="bg-white shadow-md rounded-lg p-4 mb-4">
              <h3 className="font-semibold text-gray-800 text-sm mb-2">Filters</h3>
              <div className="bg-gray-100 inline-block px-3 py-1 text-sm rounded-full text-gray-700 mb-2">
                Med Tech ✕
              </div>
              <div className="relative w-full h-12 bg-gray-100 rounded"></div>
              <div className="absolute right-8 -mt-4 bg-red-600 text-white text-xs px-1.5 py-0.5 rounded-full">
                ●
              </div>
            </div>
            <p className="text-sm text-gray-800 font-semibold">Get real-time alerts</p>
            <p className="text-sm text-gray-600 mt-1">
              See new resumes that match your search as soon as they hit the market.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResumeDatabase;
